import React from "react";
import MemberLayout from "./MemberLayout";
import { Button } from "./ui/button";
import { AlertTriangle, RotateCcw, Home } from "lucide-react";

/** Catches any runtime error inside the scenario player and shows a
 *  recoverable panel instead of a white screen. */
export class ScenarioErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Scenario player error:", error, info?.componentStack);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <MemberLayout>
        <div className="flex h-[60vh] flex-col items-center justify-center gap-4 text-center" data-testid="scenario-error-panel">
          <AlertTriangle className="h-8 w-8" style={{ color: "rgb(220, 80, 60)" }} />
          <div>
            <div className="font-heading text-lg font-semibold">Something went wrong</div>
            <p className="mt-1 text-sm text-muted-foreground">
              Your completed responses are saved. You can retry or head back to your modules.
            </p>
          </div>
          <div className="flex gap-3">
            <Button data-testid="scenario-error-retry" onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}>
              <RotateCcw className="mr-2 h-4 w-4" /> Retry
            </Button>
            <Button variant="outline" data-testid="scenario-error-home" onClick={() => { window.location.href = "/app"; }}>
              <Home className="mr-2 h-4 w-4" /> Back to modules
            </Button>
          </div>
        </div>
      </MemberLayout>
    );
  }
}

export default ScenarioErrorBoundary;
